import React from 'react'
import Error from './Error'

export default ({ error, onSubmit, isLoading, text, disabled }) =>
(
  <div className="text-center">
    <Error error={error} />
    <button
      type="submit"
      className="btn btn-purple w-100"
      onClick={onSubmit}
      disabled={disabled || isLoading}
    >
      {text}
      {isLoading && <i className="fa fa-spinner" />}
    </button>
  </div>
)
